const Row = (props) => {
  const { id, cells, model } = props

  return (
    <tr id={id ? cells[id] : null}>
      { model
        ? Object.keys(model).map((key) => {
          const { accessor, cell: customCell } = model[key]
          return (
            <td class={`qa-${accessor}`}>
              {customCell ? customCell(cells) : cells[accessor]}
            </td>
          )
        })
        : Object.keys(cells).map((key) => {
          return (<td class={`qa-${key}`}>{cells[key]}</td>)
        })
      }
    </tr>
  )
}

export default Row
